// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as CreateCustomerApiModel from "../api-model/CreateCustomerApiModel.bs.js";

function decodeOrderDetails(data) {
  return {
          customer_id: String(data.customer_id),
          status: data.status
        };
}

function execute(json) {
  return decodeOrderDetails(DeccoUtils$Catalyst.resolveResult(CreateCustomerApiModel.t_decode(json), "CraetedCustomerEntityMapper.re"));
}

export {
  decodeOrderDetails ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
